import { VHCRecordLabourInput, VhcRecordLogService } from 'api/generated';
import { ApiMutationOptions, useMutationWithNotifications } from 'api/utils/useMutationWithNotifications';

export type CreateCheckLabourInput = {
  logId: number;
  itemId: number;
  requestBody?: VHCRecordLabourInput;
};

export const useSaveCheckLabourMutation = (
  options?: ApiMutationOptions<typeof VhcRecordLogService.postVhcRecordsItemsChecksLabours, CreateCheckLabourInput>
) =>
  useMutationWithNotifications(
    ({ logId, itemId, requestBody }: CreateCheckLabourInput) =>
      VhcRecordLogService.postVhcRecordsItemsChecksLabours(logId, itemId, requestBody),
    options
  );
